import { IPendingSsnRepository } from '../../application/ports/outbound/IPendingSsnRepository';
import { PendingSsnResult } from '../../application/domain/entities/PendingSsnResult';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";
import { PendingSsnRequestDto } from './dto/req/PendingSsnRequestDto';
import { PendingSsnResponseDto } from './dto/res/PendingSsnResponseDto';
import { SubmitSsnRequestDto } from './dto/req/SubmitSsnRequestDto';
import { pendingSsnItemMapper } from './mappers/pendingSsnItemMapper';
import { HttpClient } from '@/shared/infra/http/HttpClient';

export class ApiPendingSsnRepository implements IPendingSsnRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async fetchPendingSsnRecords(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder
  ): Promise<PendingSsnResult> {
    try {
      const request: PendingSsnRequestDto = {
        page,
        pageSize,
        columnName,
        sortOrder,
      };

      const queryParams = new URLSearchParams({
        page: request.page.toString(),
        pageSize: request.pageSize.toString(),
      });

      if (request.columnName) {
        queryParams.append('columnName', request.columnName);
      }
      if (request.sortOrder) {
        queryParams.append('sortOrder', request.sortOrder);
      }

      const url = `/i9Form/pending-ssn?${queryParams.toString()}`;
      const response = await this.httpClient.getPaginated<PendingSsnResponseDto>(url);

      const pagination = response.pagination || {
        currentPage: 1,
        itemsPerPage: pageSize,
        totalItems: 0,
        totalPages: 1,
      };

      return {
        items: Array.isArray(response.data) ? response.data.map(pendingSsnItemMapper.toDomain) : [],
        pagination: {
          currentPage: pagination.currentPage,
          itemsPerPage: pagination.itemsPerPage,
          totalItems: pagination.totalItems,
          totalPages: pagination.totalPages,
        },
      };
    } catch (error) {
      console.error('Error fetching pending SSN items:', error);
      throw error;
    }
  }

  async submitSsn(i9FormId: string, ssn: string): Promise<void> {
    try {
      const requestBody: SubmitSsnRequestDto = {
        i9FormId,
        ssn,
      };

      await this.httpClient.patch('/section1/ssn', requestBody);
    } catch (error) {
      console.error('Error submitting SSN:', error);
      throw error;
    }
  }

  async sendEmailReminder(
    email: string,
    i9FormId: string
  ): Promise<void> {
    try {
      const url = '/i9Form/email-notifications/pending-ssn';
      await this.httpClient.post(url, {
        email,
        i9FormId,
      });
    } catch (error) {
      console.error('Error sending email reminder:', error);
      throw error;
    }
  }
}
